import type { Article, Locale } from '@seek/cmsu-cms-connect';
import { prefixUrlWithLanguage } from '@seek/cmsu-components/src/helpers/prefixUrlWithLanguage';
import type { BreadCrumbItem } from '@seek/cmsu-components';

const toTitleCase = (str: string): string =>
  str
    .split('-')
    .map((part) => part[0].toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');

export const getBreadcrumbItems = (
  locale: Locale,
  section: string,
  parentCategoryName: string,
  parentCategorySlug: string,
  categoryName: string,
  categorySlug: string,
  title: string = '',
) => {
  const items: BreadCrumbItem[] = [
    {
      text: toTitleCase(section),
      url: prefixUrlWithLanguage({
        url: `/${section}`,
        locale,
      }),
    },
    {
      text: categoryName,
      url: prefixUrlWithLanguage({
        url: `/${section}/category/${categorySlug}`,
        locale,
      }),
    },
  ];
  if (parentCategoryName.trim().length) {
    items.splice(1, 0, {
      text: parentCategoryName,
      url: prefixUrlWithLanguage({
        url: `/${section}/category/${parentCategorySlug}`,
        locale,
      }),
    });
  }
  if (title.trim().length) {
    items.push({
      text: title,
    });
  }
  return items;
};

export const articleActionByType = (articleType: string | null | undefined) => {
  switch (articleType?.toLowerCase()) {
    case 'video':
      return 'min watch';
    case 'podcast':
      return 'min listen';
    default:
      return 'min read';
  }
};

export const resolveArticlePathFrom = (article: Article) => {
  const section = article.category?.relatedCategorySection?.sectionName;
  return `${section ? `/${section}` : ''}/article/${article.slug}`;
};
